import React, { useState, useEffect, useCallback } from 'react';
import StatsLevel from './parts/StatsLevel';
import StatsFixe from './parts/StatsFixe';
import ProfileCard from './parts/Card';
import MoneyCounter from './parts/MoneyCounter';
import { useAuth0 } from "@auth0/auth0-react";
import Onglets from './parts/Onglets';
import NouveauPerso from './parts/NouveauPerso';
import axios from 'axios';
import { Context } from './context';
import { ReactComponent as Close } from './svg/close.svg';
import { ReactComponent as Edit } from './svg/edit.svg';

const ip = process.env.REACT_APP_IP;

const PagePerso = ({idJoueur, perso, setSelectedPerso,token }) => {
    const [actions, setActions] = useState({});
    const [personnage, setPersonnage] = useState(perso);
    const [passives, setPassives] = useState(null);
    const [spells, setSpells] = useState(null);
    const [modifPerso, setModifPerso] = useState(false);
    const [idPerso, setIdPerso] = useState(perso.idPersonnage);
    const [energies,setEnergies] = useState({})
    const { getAccessTokenSilently } = useAuth0();

    const fetchPersonnage = async () => {
        try {

            const responsePerso = await axios.get(`${ip}/perso/${idPerso}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                }
            });
            setPersonnage(responsePerso.data[0]);
            const responsePassives = await axios.get(`${ip}/passives/${idPerso}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                }
            });
            setPassives(responsePassives.data);
            const responseSpells = await axios.get(`${ip}/sorts/${idPerso}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                }
            });
            setSpells(responseSpells.data);
        } catch (error) {
            console.error("Erreur lors de la récupération du personnage :", error);
            alert("Une erreur s'est produite lors de la récupération des données.");
        }
    };

    useEffect(() => {
        fetchPersonnage();
    }, [idPerso,modifPerso]);
    const addAction = useCallback((name, func) => {
        setActions((prev) => ({ ...prev, [name]: func }));
      }, []);
    const contextValue = {
        fetchPersonnage,
        idPerso: personnage ? personnage.idPersonnage : null,
        addAction,
        actions
    };

    if (!personnage || !passives || !spells) {
        return <div>Chargement personnage en cours...</div>;
    }

    return (
        <Context.Provider value={contextValue}>


            {modifPerso ? (
                <NouveauPerso 
                energies={energies}
                idJoueur={idJoueur}
                setNewClick={setModifPerso}
                perso={personnage} 
                modif={true}
                token={token}
                />
            ) : (
                <>
                    <Close onClick={() => setSelectedPerso(null)} className='close_page' />
                    <Edit onClick={() => setModifPerso(!modifPerso)} className='edit_page' />
                    <div className='nom_prenom'></div>
                    
                    <fieldset className='top-card'>
                    <div className='width_70 modal_title '>{personnage.prenom}, {personnage.nom}</div>
                        {/* <legend className='legend_card'>{personnage.prenom}, {personnage.nom}</legend> */}
                        <ProfileCard className="margin" personnage={personnage} setEnergies={setEnergies} token={token} />
                        
                    </fieldset>

                    <MoneyCounter idPerso={personnage.idPersonnage} groupe={"solo"} token={token}/>
                    {/* <VitalityCounter idPerso={personnage.idPersonnage} setVariable={setEnergies} /> */}
                    <StatsLevel className="margin" items={personnage} />
                    <StatsFixe className="margin" items={personnage} />
                    <Onglets passives={passives} spells={spells} personnage={personnage} idPerso={personnage.idPersonnage} token={token}/>
                </>
            )}
        </Context.Provider>
    );
};

export default PagePerso;
